export default __webpack_public_path__ + "static/media/BorderToKush.04878f33.jpg";